import DataTableCheckbox_vue_vue_type_script_setup_true_lang_default from "./DataTableCheckbox.vue.script.js";
//#region src/v2/components/data-table/DataTableCheckbox.vue
var DataTableCheckbox_default = DataTableCheckbox_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DataTableCheckbox_default as default };

//# sourceMappingURL=DataTableCheckbox.vue.js.map